import gql from 'graphql-tag';

// Query for general form data
export const formQuery = gql`
  query(
    $instId: String
    $locId: String
    $source: String
    $originalSource: String
    $userkey: String
    $sessionid: String
  ) {
    formData(
      userkey: $userkey
      sessionid: $sessionid
      loc_id: $locId
      inst_id: $instId
      source: $source
      original_source: $originalSource
    ) {
      instId
      institution_name
      locId
      location_name
      verticalId
      title
      subtitle
      success_title
      success_subtitle
      success_description
      redirect_url
      redirect_newtab
      requiresGDPRCompliance
      lastCompletedStep
      currentVisitorType
      large_form_image
      steps {
        stepId
        fields {
          label
          fieldId
          inputType
          disabled
          required
          errorMessage
          show_if
          constrain_by
          sortOrder
          defaultValue
          placeholder
          list {
            value
            label
            group
          }
        }
      }
      completedFields
    }
  }
`;

// WelcomeHeader QUERY
export const WELCOME_HEADER_QUERY = `
  query () {
    formData() {
      title
      subtitle
    }
  }
`;
